<template>
  <div
    id="filter-menu"
    class="filter-menu-section inner-filter-menu"
    :class="{ fixed_top: fixTop }"
    v-if="all_store_categories.length > 0"
  >
    <h1 v-if="all_store_menu_items_being_loaded">{{ _T('LOADING') }}....</h1>
    <div class="filter-menu" v-else>
      <categories></categories>
      <search-bar />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { seo_name } from '@/utils/main_utils'
import Categories from '@/components/Collections/Categories'
import SearchBar from '@/components/Blocks/SearchBar'
import { eventBus } from '@/eventBus'
export default {
  name: 'Navigation',
  components: { Categories, SearchBar },
  data() {
    return {
      fixTop: false,
      dnone: false,
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    this.$store.commit('SET_ITEM_SEARCH_TERM', '')
  },
  methods: {
    seoName(name) {
      return seo_name(name)
    },
    // eslint-disable-next-line no-unused-vars
    handleScroll(event) {
      var element = document.querySelector('#footer-color')
      var position = element.getBoundingClientRect()

      //checking whether fully visible
      if (position.top >= 0 && position.top <= window.innerHeight) {
        this.dnone = true
      } else {
        this.dnone = false
      }
      if (window.scrollY > 250) this.fixTop = true
      else this.fixTop = false
    },
  },
  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'all_store_menu_items_being_loaded',
      'all_store_categories',
    ]),
  },
  beforeDestroy() {
    eventBus.$off('clear-search')
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .filter-menu-section {
    .search-bar {
      .form-group {
        svg {
          left: 0.9375rem;
          right: unset;
        }
      }
    }
  }
}
.filter-menu-section {
  position: sticky;
  z-index: 1;
  background-color: $white;
  top: $px86;
  .filter-menu {
    display: flex;
    border-bottom: $px1 solid $light-border;
  }

  &.inner-filter-menu {
    padding-top: $px20;
    padding-left: $px30;
    padding-bottom: $px35;
    position: relative;
    top: 0;
    .search-bar {
      padding-right: $px30;
    }
    &.fixed_top {
      position: fixed;
      width: 100%;
      flex: 0 0 100%;
      max-width: 100%;
      top: $px83;
      z-index: 1;
      padding-left: $px30;
      padding-bottom: $px20;
      .filter-menu {
        padding: 0;
      }
      .search-bar {
        .form-group {
          margin-bottom: $px10;
          margin-top: $px10;
          .form-control {
            border: $px1 solid $light-border;
          }
        }
      }
      &.sticky_up {
        top: $px131;
      }
    }
    &.filter-menu-sticky {
      position: fixed;
      left: 0;
      width: 100vw;
      top: $px159;
      z-index: 1;
      background-color: $white;
      border-top: $px1 solid $light-border;
      padding-bottom: 0;
    }
  }
  &.choose-menu-filter {
    padding-bottom: 0;
    top: $px99;
    z-index: 4;
    margin-bottom: $px30;
    .filter-menu {
      padding-top: $px20;
    }
  }
}
@media (max-width: 1367px) {
  .filter-menu-section {
    .search-bar {
      margin-left: $px20;
    }
    &.inner-filter-menu {
      &.fixed_top {
        top: $px83;
      }
    }
  }
}
@media (max-width: 1199px) {
  .filter-menu-section {
    &.inner-filter-menu {
      padding-top: $px10;
      padding-left: $px10;
      padding-bottom: $px25;
      //z-index: 3;
      .search-bar {
        margin-bottom: $px10;
        padding-right: $px10;
        .form-group {
          margin-bottom: 0;
          max-width: $px200;
        }
      }
      &.fixed_top {
        flex: 0 0 66.67%;
        max-width: 66.67%;
        width: 66.67%;
        top: $px83;
        padding-left: $px10;
        padding-bottom: $px10;
        .search-bar {
          margin-bottom: 0;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .filter-menu-section {
    .search-bar {
      display: none;
    }
    .filter-menu {
      overflow: -moz-scrollbars-none;
      -ms-overflow-style: none;
      margin-right: $px10;
      ::-webkit-scrollbar {
        width: 0 !important;
      }
    }
    &.inner-filter-menu {
      &.fixed_top {
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
      }
    }
  }
}
@media (max-width: 767px) {
  .filter-menu-section {
    position: relative;
    top: 0;
    z-index: 0;
    &.inner-filter-menu {
      padding: $px15 0;
      border-top: $px12 solid $light-border;
      &.fixed_top {
        position: fixed;
        top: 0;
        border-top: none;
        padding-left: 0;
      }
      .filter-menu {
        padding: 0 0 0 $px15 !important;
      }
      &.filter-menu-sticky {
        top: $px140;
      }
    }
    &.choose-menu-filter {
      position: sticky;
      z-index: 2;
    }
  }
}
@media (max-width: 575px) {
  .filter-menu-section {
    padding-top: $px15;
    padding-bottom: 0;
    .filter-menu {
      border-bottom: none;
    }
    &.inner-filter-menu {
      &.filter-menu-sticky {
        top: $px159;
      }
    }
  }
}
</style>
